// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xM8BX","right":"styles_right__gZEf2"};